import {useState} from "react"
export const usePost =()=>{
    const [postError,setPostError]=useState(null);
    const [isPending,setIsPending]=useState(false);
    const [resData,setResData]=useState(null);
    const postData=(url,postData,method)=>{
        setPostError(null);
        setIsPending(true);
        fetch(url,{
        method: method,
        headers:{
            'Content-Type':'application/json',
        },
        ...(method !== 'GET' && { body: JSON.stringify(postData) })
        }
        ).then(res=>res.json()).then((data)=>{
            try {
                if (data.status !== 200 && data.status !== 201) {
                    
                    if (data.error) {
                        if (data.status === 403) {
                            setPostError(data)
                        } else {
                            throw new Error(data.error);
                        }
                    }
                    else{
                        throw new Error("Oops! something went wrong.")
                    }  
                }
                console.log(data)
                setResData(data);
                setIsPending(false);

            }catch(err){
                console.log(err.message);
                setPostError(err.message);
                setIsPending(false);
            }
        })
    }

return{postData,resData,postError,isPending}
}
